import { added } from "../actions";
import { url } from "../../../url";


const addTodo = (todoText) => {
    return async (dispatch) => {
        const response = await fetch(url, {
            method: "POST",
            body: JSON.stringify({
                text: todoText,
                completed: false,
            }),
            headers: { "Content-Type": "application/json; charset=utf-8" },
        });
        const todo = await response.json();

        dispatch(added(todo.text));
    }
};

export default addTodo;